export default "__VITE_ASSET__C41Hu6wB__"